module.exports = __webpack_public_path__ + "static/media/sp_glasphalt_carbophalt_g.cd683b07.jpg";